<template>
  <div>
    <div class="diaContainer yauto">
      <!-- 到账记录新增表单 -->
      <el-form
        ref="addArrivalForm1"
        :model="addArrivalForm"
        v-if="showForm==='showFormEndAdd'"
        label-position="left"
        :rules="rules"
        label-width="160px"
      >
        <div class="diaForm_box">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称 " v-else>

             <!-- 在本地搜索 -->
              <!-- <el-select
                style="width:100%"
                v-model="addArrivalForm.project_id"
                filterable
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select> -->

              <!-- 远程搜索 -->
              <el-select
                style="width:100%"
                v-model="addArrivalForm.project_id"
                filterable
                remote
                multiple
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                :filter-method="projectSearch"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>


            </el-form-item>
            <!-- 项目编号 -->
            <!-- <el-form-item label="项目编号" style="margin-bottom:0">
                <span>{{selectProjectNum}}</span>
            </el-form-item>-->
          </div>
        </div>
        <div class="diaForm_box">
          <div class="diaFormTitle">费用信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addArrivalForm.member">
              <span
                v-if="addArrivalForm.member"
                style="color:#666;font-size:16px"
              >{{addArrivalForm.member.nickname}}</span>
            </el-form-item>
            <div
              style="font-size:12px;margin-left:160px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*此项为财务人员对项目的到账金额进行查账填写，相关项目的登记人、主办、负责人、业务，都会收到对应到账信息。</div>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              style="margin-bottom:30px;"
              prop="preset_member"
              v-if="$store.state.process.finance.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addArrivalForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.finance.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 是否到账结清 -->
            <el-form-item label="是否到账结清" style="margin-bottom:0px;">
              <el-radio-group v-model="addArrivalForm.is_settle" :disabled="draftDisable">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 是否可申请结算 -->
            <el-form-item label="是否可申请结算" style="margin-bottom:0px;">
              <el-radio-group
                @change="jiesuanChangeClick"
                v-model="addArrivalForm.is_settlement"
                :disabled="draftDisable"
              >
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 到账金额 -->
            <el-form-item label="到账金额">
              <el-input
                :disabled="draftDisable"
                type="number"
                placeholder="请输入您的到账金额"
                v-model="addArrivalForm.total"
              ></el-input>
              <div style="width:40px;text-align:center;line-height:40px;">元</div>
            </el-form-item>
            <!-- 到账日期 -->
            <el-form-item label="到账日期">
              <!-- <el-input placeholder="到账日期" v-model="addArrivalForm.name"></el-input> -->
              <el-date-picker
                :disabled="draftDisable"
                v-model="addArrivalForm.date"
                type="date"
                style="width:100%"
                placeholder="到账时间"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addArrivalForm.remark"
              ></el-input>
            </el-form-item>
            <!-- 附件 -->
            <el-form-item label="附件" style="margin-bottom:20px">
              <upload-file
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- 到账记录审批表单 -->
      <el-form
        ref="addArrivalForm2"
        :model="addArrivalForm"
        v-if="showForm==='showFormEndHandle'"
        :rules="rules"
        label-position="left"
        label-width="160px"
      >
        <div class="diaForm_box diaEditFormBox">
          <div class="ShowFormBtn">
            <el-button
              v-if="addArrivalForm.withdraw_status=='1'"
              @click="handleFinnaceWithDraw('arrival',addArrivalForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >撤回</el-button>
            <el-button
              v-if="addArrivalForm.is_just=='1'"
              @click="handleFinnaceApproveWithDraw('arrival',addArrivalForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >审批撤回</el-button>
            <el-button
              @click="approveVisible=true"
              v-if="addArrivalForm.approval_status=='1'"
              class="creat"
              style="background-color:#40A0F2;"
            >去审批</el-button>
          </div>
        </div>
        <div
          class="diaForm_box diaEditFormBox"
          v-if="addArrivalForm.is_edit=='1' || (addArrivalForm.project_list && addArrivalForm.project_list.length>0)"
        >
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" class="containerNoDis" v-else>
             <!-- 搜索标记1 -->
              <el-select
                style="width:100%"
                v-model="addArrivalForm.project_id"
                filterable
                v-if="addArrivalForm.is_edit=='1'"
               
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
                :filter-method="projectSearch"
                remote
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>
              <span
                v-else
                class="projectContainerInbox"
                :key="items.project_id"
                v-for="(items,index) in addArrivalForm.project_list"
                style="color:#666;font-size:16px;"
              >
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-if="index<addArrivalForm.project_list.length-1"
                >{{items.project_name+','}}</span>
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-else
                >{{items.project_name}}</span>
              </span>
            </el-form-item>
            <!-- 项目编号 -->
            <!-- <el-form-item label="项目编号" style="margin-bottom:10px">
                <span style="color:#666;font-size:16px">{{selectProjectNum}}</span>
            </el-form-item>-->
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">费用信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addArrivalForm.member">
              <span
                v-if="addArrivalForm.member"
                style="color:#666;font-size:16px"
              >{{addArrivalForm.member.nickname}}</span>
            </el-form-item>
            <div
              style="font-size:12px;margin-left:160px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*此项为财务人员对项目的到账金额进行查账填写，相关项目的登记人、主办、负责人、业务，都会收到对应到账信息。</div>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              style="margin-bottom:30px;"
              prop="preset_member"
              v-if="addArrivalForm.is_edit=='1' && $store.state.process.finance.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addArrivalForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.finance.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 是否到账结清 -->
            <el-form-item label="是否到账结清" style="margin-bottom:0px;">
              <el-radio-group v-model="addArrivalForm.is_settle" v-if="addArrivalForm.is_edit=='1'">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
              <span v-else style="color:#666;font-size:16px">
                <span v-if="addArrivalForm.is_settle=='1'">是</span>
                <span v-if="addArrivalForm.is_settle=='0'">否</span>
              </span>
            </el-form-item>
            <!-- 是否可申请结算 -->
            <el-form-item label="是否可申请结算" style="margin-bottom:0px;">
              <el-radio-group
                @change="jiesuanChangeClick"
                v-model="addArrivalForm.is_settlement"
                v-if="addArrivalForm.is_edit=='1'"
              >
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
              <span v-else style="color:#666;font-size:16px">
                <span v-if="addArrivalForm.is_settlement=='1'">是</span>
                <span v-if="addArrivalForm.is_settlement=='0'">否</span>
              </span>
            </el-form-item>
            <!-- 到账金额 -->
            <el-form-item label="到账金额" style="margin-bottom:0px;">
              <el-input
                type="number"
                v-if="addArrivalForm.is_edit=='1'"
                placeholder="请输入您的到账金额"
                v-model="addArrivalForm.total"
              ></el-input>
              <div
                v-if="addArrivalForm.is_edit=='1'"
                style="width:40px;text-align:center;line-height:40px;"
              >元</div>
              <span v-else style="color:#666;font-size:16px">{{addArrivalForm.total}}</span>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注">
              <el-input
                v-if="addArrivalForm.is_edit=='1'"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addArrivalForm.remark"
              ></el-input>
              <el-input
                type="textarea"
                class="onlyShowText"
                disabled
                autosize
                v-else
                v-model="addArrivalForm.remark"
              ></el-input>
            </el-form-item>
            <!-- 到账日期 -->
            <el-form-item label="到账日期">
              <el-date-picker
                v-model="addArrivalForm.date"
                type="date"
                v-if="addArrivalForm.is_edit=='1'"
                style="width:100%"
                placeholder="到账时间"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <span v-else style="color:#666;font-size:16px">{{addArrivalForm.date}}</span>
            </el-form-item>
            <!-- 附件 -->
            <el-form-item label="附件" style="margin-bottom:20px">
              <upload-file
                style="width:100%"
                :isSubmit="addArrivalForm.is_edit=='1'"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
          </div>
        </div>

        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">审批信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 已通过 -->
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in addArrivalForm.approval_log"
                :color="activity.approval_status==0?'':'#128bf1'"
                :key="index"
              >
                <div style="margin-bottom:5px">
                  <span>提交人:</span>
                  <span>{{activity.memberInfo.nickname}}</span>
                  <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                  <span>{{activity.add_time}}</span>
                </div>
                <div>
                  <span
                    v-if="activity.approval_status=='1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                  <span
                    v-if="activity.approval_status=='-1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                  <span
                    v-if="activity.approval_status=='-2'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-2'" style="color:rgb(255, 51, 51)">审批撤回</span>
                  <span
                    v-if="activity.approval_status=='0'"
                    v-for="item in activity.tomemberInfo"
                    style="margin-right:10px"
                  >{{item.nickname+' '}}</span>
                  <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                  <span
                    style="margin-left:10px"
                    v-if="activity.update_time"
                  >{{activity.update_time}}</span>
                </div>
                <div class="remark" style="margin-top:5px" v-if="activity.remark">
                  <span style="margin-right:5px">备注:</span>
                  <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 到账记录新增按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormEndAdd' && addArrivalForm.is_draft!='1'"
        @click="handleAddArrivalSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormEndAdd' && addArrivalForm.is_draft!='1'"
        @click="handleAddArrivalSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 到账记录编辑按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormEndAdd' && addArrivalForm.is_draft=='1' && !draftDisable"
        @click="handleEditArrivalSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormEndAdd' && addArrivalForm.is_draft=='1' && !draftDisable"
        @click="handleEditArrivalSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 到账记录重新提交 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormEndHandle' && addArrivalForm.is_edit=='1'"
        @click="getDialogVisible(false)"
      >取 消</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormEndHandle' && addArrivalForm.is_edit=='1'"
        @click="handleEditArrivalSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 签名组件 -->
    </div>
    <sign-dialog
      @wirtDoen="handleWriteDone"
      :visible.sync="receiverSignFlag"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 弹窗--审批 -->
    <el-dialog
      :visible.sync="approveVisible"
      width="60%"
      class="addClientDia"
      :before-close="approveVisibleClose"
      append-to-body
      @close="approveVisibleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">审批</span>
      </div>
      <div>
        <el-form ref="form" label-position="right" label-width="160px">
          <div class="diaForm_box diaEditFormBox">
            <div
              v-if="addArrivalForm.approval_status=='1'"
              style="font-size:12px;padding-right:30px;text-align:right;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*您可以选择驳回后发起人提交的节点</div>
            <!-- 自动审批大通按钮 -->
            <el-form-item label="自动审批" v-if="addArrivalForm.approval_status=='1'">
              <div style="height:40px;display:flex;align-items:center;">
                <el-switch
                  active-value="1"
                  inactive-value="0"
                  v-model="is_chase"
                  active-color="#128bf1"
                  inactive-color="#ccc"
                ></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="驳回节点" v-if="addArrivalForm.approval_status=='1'">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择" clearable>
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addArrivalForm.stage_selectArry"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批备注" v-if="addArrivalForm.approval_status=='1'">
              <el-input
                style="width:95%"
                placeholder="审批备注"
                type="textarea"
                v-model="approvalRemark"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="签名"
              v-if="addArrivalForm.approval_status=='1'"
              style="margin-bottom:20px"
            >
              <img
                v-if="!sign_pic"
                @click="handleReceiverFlag"
                style="width:66px;height:66px;"
                src="../../../assets/image/zaixianqianm@2x.png"
                alt
              />
              <img
                v-if="sign_pic"
                @click="handleReceiverFlag(sign_pic)"
                style="width:66px;height:66px;"
                :src="sign_pic"
                alt
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="handleFinnaceApproval('-1','arrival',addArrivalForm.id)"
          :disabled="disableLimit"
          v-if="addArrivalForm.approval_status=='1'"
          style="background:#f4a029;"
          class="search"
        >驳回</el-button>
        <el-button
          @click="handleFinnaceApproval('1','arrival',addArrivalForm.id)"
          :disabled="disableLimit"
          v-if="addArrivalForm.approval_status=='1'"
          class="creat"
          style="background-color:#40A0F2;"
        >通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

import TableJson from '../../TableJson'
import UploadFile from '../../../components/UploadFile'
import SignDialog from '../../../components/SignDialog'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  data() {
    return {
      approveVisible: false,
      sign_pic: '',
      receiverSignFlag: false,
      // 禁用按钮防抖
      disableLimit: false,
      // 弹窗
      imgList: [],
      detailsImgList: [],
      k_code: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      // 新增到账记录表单
      addArrivalForm: {
        is_settle: '0',
        is_settlement: '0',
        project_list: [],
        total: '',
        date: '',
        remark: '',
        annex: '',
        project_id: [],
        preset_member: '',
      },
      tiemID1: null,
      timeDou: 100,
      selectProjectNum: '',
      approvalRemark: '',
      // 自动审批大通
      is_chase: '0',
      rules: {
        preset_member: [
          { required: true, message: '请选择预设审批人', trigger: 'change' },
        ],
      },
    }
  },
  props: [],
  components: {
    UploadFile,
    SignDialog,
    TableJson,
  },
  watch: {
    '$store.state.process.finance.formData'(newval, olval) {
      this.addArrivalForm = newval
      console.log('this.addArrivalForm')
    },
    '$store.state.process.finance.dialogVisible'(newval, olval) {
      if (newval == false) {
        this.is_chase = '0'
      }
    },
    'addArrivalForm.annex': {
      handler: function (val, oldVal) {
        this.imgList = val
        this.detailsImgList = val
      },
    },
    'addArrivalForm.is_settle': {
      handler: function (val, oldVal) {
        if (val == '1') {
          this.addArrivalForm.is_settlement = '1'
        }
      },
    },
    // 默认驳回节点是当前节点
    'addArrivalForm.stage_selectArry': {
      handler: function (val, oldVal) {
        if (val && val.length > 0) {
          this.k_code = val[val.length - 1].id
        } else {
          this.k_code = ''
        }
      },
    },
  },

  methods: {

 // 按搜索条件查找，不在本地进行查找
 async projectSearch(val){
   if(!val)return
   console.log(val)
    let param = new FormData()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
      
      param.append('search', val)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      console.log(res.datas.listInfo)
      this.$store.commit(
        'process/finance/assignmentProject',
        res.datas.listInfo
      )
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo
        )
      }
      console.log('获取项目列表', this.$store.state.process.finance.projectList)
     
   },

    ...mapMutations('process/finance', ['getDialogVisible']),
    projectFilter(query = '') {
      let arr = this.projectList.filter((item) => {
        return (
          item.project_id.includes(query) || item.project_show.includes(query)
        )
      })
      console.log('arr', arr)
      if (arr.length == 0) {
        this.$forceUpdate()
      }
      if (arr.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          arr.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit('process/finance/setprojectListSub', arr)
      }
    },
    handleProjectSelectBlur1(val) {
      if (!val) {
        if (this.projectList.length > this.moreNum) {
          this.$store.commit(
            'process/finance/setprojectListSub',
            this.projectList.slice(0, this.moreNum)
          )
        } else {
          this.$store.commit(
            'process/finance/setprojectListSub',
            this.projectList
          )
        }

        console.log('this.projectListSub', this.projectListSub)
      }
    },
    jiesuanChangeClick() {
      if (this.addArrivalForm.is_settle == '1') {
        this.addArrivalForm.is_settlement = '1'
      }
    },
    handleReceiverFlag(url) {
      this.receiverSignFlag = true
    },
    handleWriteDone(data) {
      this.sign_pic = data
    },
    handleReceiverSign() {},

    // 点击新窗口打开项目页面
    goProjectDetailsOpenNew(items) {
      console.log('items', items)
      // this.$router.resolve({
      //   path: '/project/details/task',
      //   query: {
      //     project_id: items.project_id,
      //     project_name: items.project_name,
      //     isEdit: '1',
      //   },
      // })
      let routeUrl = this.$router.resolve({
        path: '/project/details/task',
        query: {
          project_id: items.project_id,
          project_name: items.project_name,
          isEdit: '1',
          formFinance: '1',
          project_status: '',
        },
      })
      window.open(routeUrl.href)
    },
    upLoadChange(data) {
      this.imgList = data
    },
    // *审批撤回
    async handleFinnaceApproveWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approve_withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *撤回
    async handleFinnaceWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)
      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }

      this.getDialogVisible(false)
    },
    // *财务审批(详情页点击通过或驳回)
    async handleFinnaceApproval(val, stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      param.append('approval_status', val)
      param.append('remark', this.approvalRemark)
      param.append('k_code', this.k_code)
      param.append('is_chase', this.is_chase)

      param.append('sign_pic', this.sign_pic)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.$message.success(res.datas.msg)
      this.disableLimit = false
      // 清空驳回节点
      this.k_code = ''
      this.sign_pic = ''
      this.approvalRemark = ''
      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }

      this.getDialogVisible(false)
      this.approveVisible = false
    },

    // *编辑到账记录提交
    async handleEditArrivalSubmit(val) {
      if (this.$store.state.process.finance.list3.length > 0) {
        // 判断是不是草稿
        if (this.addArrivalForm.is_draft == '1') {
          this.$refs.addArrivalForm1.validate(async (valid) => {})
        } else {
          this.$refs.addArrivalForm2.validate(async (valid) => {})
        }
      }

      this.disableLimit = true
      if (this.addArrivalForm.date == null) {
        this.addArrivalForm.date = ''
      }
      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)
        param.append('finance_id', this.addArrivalForm.id)

        param.append('preset_member', this.addArrivalForm.preset_member)
        param.append('total', this.addArrivalForm.total)
        param.append('date', this.addArrivalForm.date)
        param.append('remark', this.addArrivalForm.remark)
        param.append('annex', JSON.stringify(this.imgList))

        param.append('is_settle', this.addArrivalForm.is_settle)
        param.append('is_settlement', this.addArrivalForm.is_settlement)

        // // 单选
        // if (
        //   Array.isArray(this.addArrivalForm.isOld_project_id) &&
        //   !this.addArrivalForm.project_id
        // ) {
        //   param.append(
        //     'project_id',
        //     this.addArrivalForm.isOld_project_id.join(',')
        //   )
        // } else {
        //   param.append('project_id', this.addArrivalForm.project_id)
        // }

        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append('project_id', this.addArrivalForm.project_id.join(','))
        }

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/arrival_edit',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }

        this.getDialogVisible(false)
      }, this.timeDou)
    },
    // *到账记录新增点击提交
    async handleAddArrivalSubmit(val) {
      if (this.$store.state.process.finance.list3.length > 0) {
        this.$refs.addArrivalForm1.validate(async (valid) => {
          //   如果校验失败
          if (valid == false) return
          // 如果校验成功
        })
      }

      this.disableLimit = true
      if (this.addArrivalForm.date == null) {
        this.addArrivalForm.date = ''
      }

      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)

        param.append('preset_member', this.addArrivalForm.preset_member)
        param.append('total', this.addArrivalForm.total)
        param.append('date', this.addArrivalForm.date)
        param.append('remark', this.addArrivalForm.remark)
        param.append('annex', JSON.stringify(this.imgList))

        param.append('is_settle', this.addArrivalForm.is_settle)
        param.append('is_settlement', this.addArrivalForm.is_settlement)

        // 多选
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append('project_id', this.addArrivalForm.project_id.join(','))
        }
        // // 单选
        // param.append('project_id', this.addArrivalForm.project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/arrival_add',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }

        this.getDialogVisible(false)
      }, this.timeDou)
    },
    getList() {
      if (this.$store.state.process.finance.isFromProjectBar) {
        this.$store.commit(
          'process/finance/getArrivalList',
          this.$store.state.process.finance.projectId
        )
        this.$store.commit(
          'process/finance/getFinanceSildeBarNum',
          this.$store.state.process.finance.projectId
        )
      } else {
        this.$store.commit('process/finance/getArrivalList')
      }
    },
    // 选择项目名称1
    async handleProjectSelectChange1(val) {
      if (val && val.length > 1) {
        this.$message.error('关联项目只能选择1个')
        this.addArrivalForm.project_id = [val[0]]
      }
      // 强制刷新组件
      this.$forceUpdate()
    },
    approveVisibleClose() {
      this.approveVisible = false
    },
    approveVisibleClosed() {
      this.is_chase = '0'
      this.k_code = ''
      this.approvalRemark = ''
      this.sign_pic = ''
    },
  },

  onload(){
   console.log('onload')
   console.log(this.addArrivalForm)
  },

  async created() {
   console.log('this.addArrivalForm1111')
   console.log(this.addArrivalForm)
    this.addArrivalForm = JSON.parse(
      JSON.stringify(this.$store.state.process.finance.formData)
    )
    if (this.addArrivalForm.annex) {
      this.imgList = this.addArrivalForm.annex
      this.detailsImgList = this.addArrivalForm.annex
    }
    this.disableLimit = false

    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    // alert(this.member_id)
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
  },
  mounted() {},
  computed: {
    ...mapState('process/finance', [
      'showForm',
      'draftDisable',
      'formData',
      'moreNum',
      'projectList',
      'projectListSub',
    ]),
  },
}
</script>
<style lang="less" scoped>
@import url(../../../views/topBar/finance.scss);
.search-keyword-more {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #999;
}
</style>